// Custom session service to replace redux-react-session
// Uses localStorage to persist session data

const SESSION_KEY = 'redeye_session'
const USER_KEY = 'redeye_user'

let store = null

export const sessionService = {
  initSessionService: (reduxStore) => {
    store = reduxStore
    // Load session from localStorage on init
    const session = sessionService.loadSessionSync()
    const user = sessionService.loadUserSync()
    if (session && user) {
      // Restore adminSelectedNetwork from session if it exists
      if (session.adminClientId) {
        store.dispatch({ type: 'ADMIN_SELECT_NETWORK', payload: session.adminClientId })
      }
    }
  },

  saveSession: (session) => {
    try {
      localStorage.setItem(SESSION_KEY, JSON.stringify(session))
      return Promise.resolve(session)
    } catch (err) {
      return Promise.reject(err)
    }
  },

  loadSession: () => {
    try {
      const session = localStorage.getItem(SESSION_KEY)
      if (session) {
        return Promise.resolve(JSON.parse(session))
      }
      return Promise.reject('Session not found')
    } catch (err) {
      return Promise.reject(err)
    }
  },

  loadSessionSync: () => {
    try {
      const session = localStorage.getItem(SESSION_KEY)
      return session ? JSON.parse(session) : null
    } catch (err) {
      return null
    }
  },

  deleteSession: () => {
    try {
      localStorage.removeItem(SESSION_KEY)
      return Promise.resolve()
    } catch (err) {
      return Promise.reject(err)
    }
  },

  saveUser: (user) => {
    try {
      localStorage.setItem(USER_KEY, JSON.stringify(user))
      return Promise.resolve(user)
    } catch (err) {
      return Promise.reject(err)
    }
  },

  loadUser: () => {
    try {
      const user = localStorage.getItem(USER_KEY)
      if (user) {
        return Promise.resolve(JSON.parse(user))
      }
      return Promise.reject('User not found')
    } catch (err) {
      return Promise.reject(err)
    }
  },

  loadUserSync: () => {
    try {
      const user = localStorage.getItem(USER_KEY)
      return user ? JSON.parse(user) : null
    } catch (err) {
      return null
    }
  },

  deleteUser: () => {
    try {
      localStorage.removeItem(USER_KEY)
      return Promise.resolve()
    } catch (err) {
      return Promise.reject(err)
    }
  }
}

// Session reducer for Redux store (replaces sessionReducer from redux-react-session)
const initialState = {
  authenticated: false,
  checked: false,
  user: null
}

export const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION_CHECKED':
      return { ...state, checked: true }
    case 'SESSION_AUTHENTICATED':
      return { ...state, authenticated: true }
    case 'SESSION_LOGOUT':
      return { ...state, authenticated: false, user: null }
    case 'SESSION_USER_LOADED':
      return { ...state, user: action.payload }
    default:
      return state
  }
}

export default sessionService
